///<reference path="./resources.js"/>
///<reference path="./Extensions.js"/>
/******* Localization ********/
function Resx(defaultCategory) {
  this._defaultCategory = defaultCategory;
  this._localizedStrings = localizedStrings;
}
with (Resx) {
  (prototype.GetString = function() {
    return this._translateString(arguments).text;
  }),
    (prototype.TranslateString = function() {
      var translation = this._translateString(arguments);
      var text = translation.text;
      if (!translation.successful) {
        if (2 <= arguments.length) {
          text = arguments[1];
        } else if (1 <= arguments.length) {
          text = arguments[0];
        }
      }
      return text;
    }),
    (prototype._translateString = function() {
      var translation = new Object();
      translation.successful = true;
      var category = null;
      var key = null;
      var defaultMessage = null;
      if (2 <= arguments[0].length) {
        category = arguments[0][0];
        key = arguments[0][1];
      } else if (1 <= arguments[0].length) {
        key = arguments[0][0];
      }
      // Assign the default category if one wasn't provided
      if (String.IsNullOrEmpty(category)) {
        category = this._defaultCategory;
      }
      // Ensure the category and key has been specified (traps invalid defaultCategories)
      if (String.IsNullOrEmpty(category) || String.IsNullOrEmpty(key)) {
        translation.successful = false;
        return String.Format(
          "!!Resx: Invalid category '{0}' and/or key '{1}'",
          category,
          key
        );
      }
      // Lower() category and key
      category = category.toLowerCase();
      key = key.toLowerCase();
      // Ensure the category exists
      var cat = this._localizedStrings[category];
      if (cat == null) {
        translation.successful = false;
        return String.Format(
          "!!Resx: The category '{0}' was not found",
          category
        );
      }
      // Ensure the key exists
      var value = cat[key];
      if (value == null) {
        translation.successful = false;
        return String.Format(
          "!!Resx: The key '{0}' in category '{1}' was not found",
          key,
          category
        );
      }
      translation.text = value;
      return translation;
    });
  prototype.Format = String.Format;
}
var resx = new Resx("core");
